/******/ (function() { // webpackBootstrap
var __webpack_exports__ = {};
class MiniCart extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }
  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    fetch(this.dataset.url).then(response => response.text()).then(html => {
      document.getElementById('mini-cart').innerHTML = this.getSectionInnerHTML(html, '.shopify-section');
      document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
    }).catch(e => {
      console.error(e);
    });
  }
  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    this.drawer.openMenuDrawer();
  }
  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach(section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    });
    this.open();
    setTimeout(() => {
      this.focusOnCartDrawer();
    }, 100);
  }
  getSectionsToRender() {
    return [{
      id: 'mini-cart',
      section: 'mini-cart',
      selector: '.shopify-section'
    }, {
      id: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '.shopify-section'
    }, {
      id: 'mobile-cart-icon-bubble',
      section: 'mobile-cart-icon-bubble',
      selector: '.shopify-section'
    }];
  }
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
  focusOnCartDrawer() {
    const closeButton = document.querySelector('.mini-cart__header drawer-close-button');
    if (!closeButton) return;
    closeButton.focus();
    setTimeout(() => {
      if (document.activeElement !== closeButton) {
        closeButton.focus();
      }
    }, 50);
  }
}
customElements.define('mini-cart', MiniCart);
/******/ })()
;